// extracted by mini-css-extract-plugin
export var chip = "_3d-9";
export var chipLabel = "_3d-a";
export var close = "_3d-7";
export var closeIcon = "_3d-8";
export var error = "_3d-6";
export var infoTooltip = "_3d-2";
export var innerContainer = "_3d-1";
export var input = "_3d-b";
export var medium = "_3d-5";
export var outerContainer = "_3d-0";
export var small = "_3d-4";
export var xSmall = "_3d-3";